<template>
	<div class="order-details-skeleton" role="status">
		<span class="order-details-skeleton__label">Loading order details</span>
		<Skeleton v-for="row in 3" :key="row" height="--size-96" radius="--size-36" />
	</div>
</template>

<script setup lang="ts">
import { Skeleton } from '@simple-life-app/growth-ui-kova'

/**
 * The details while the first read of an order is in flight (spec §6.2 "Loading"): no cached order to show. No Figma
 * frame exists for it, and the ticket asks for a loading state, not the details' shape: three DS `Skeleton` rows,
 * round and 8 apart like the details' cards, the same in the drawer and on the page. Announced once as a polite
 * status; the rows are the DS's own `aria-hidden`, and stop their shimmer under prefers-reduced-motion.
 */
</script>

<style scoped>
.order-details-skeleton {
	display: flex;
	flex-direction: column;
	gap: var(--size-8);
}

/* Read by screen readers, not drawn. */
.order-details-skeleton__label {
	position: absolute;
	width: 1px;
	height: 1px;
	overflow: hidden;
	clip-path: inset(50%);
	white-space: nowrap;
}
</style>
